<template>
  <div>
    <span v-if="data.column.field === 'active'">
      <div class="d-flex justify-content-between text-align-left">
        <span>
          <i
            v-if="data.formattedRow.active"
            class="chart-dot-green mr-50"
          />
          <i
            v-else
            class="chart-dot-red mr-50"
          />
          {{ capitalizeFirstLetter(data.formattedRow.active.toString()) }}
        </span>
        <span>
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template v-slot:button-content>
              <GjIcon
                name="Moreoptions_fill"
                class="text-body align-middle mr-25"
              />
            </template>
            <b-dropdown-item
              :to="`/admin/info/${data.row.groupId}/section/${data.row.id}`"
            >
              <GjIcon
                name="Edit"
                class="mr-50"
              />
              <span>{{ $tk('ClientPortal.Admin.Edit') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </span>
      </div>
    </span>
    <span v-else-if="data.column.field === 'name'">
      <b-button
        variant="link"
        :to="`/admin/info/${data.row.groupId}/section/${data.row.id}`"
        size="sm"
      >
        {{ data.formattedRow.name }}
      </b-button>
    </span>

    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1)
    return { capitalizeFirstLetter }
  },
}
</script>
